import React from "react";
import { ArrowRight } from "lucide-react";
import Card, { Kicker } from "../brand/Surface";
import Action from "../brand/Action";
import Reveal from "../brand/Reveal";
import Skills from "../brand/Skills";
import Timeline from "../brand/Timeline";
import Band from "../brand/Band";
import Hl from "../brand/Hl";

/**
 * Everything under the fold: what I reach for, and where it started.
 *
 * Three sections have been cut from this page over time and none of them are
 * coming back: progress bars claiming "React 87%", a "What Drives Me" block
 * full of adjectives, and a numbered "how I work" manifesto. A number nobody
 * can check is worse than no number, and a list of rules about how carefully
 * one works is the one thing on a portfolio that the work itself already
 * proves or already disproves.
 */
export default function About() {
  return (
    <div className="flex flex-col gap-4">
      {/* --------------------------------------------------------- skills */}
      <Reveal>
        <Skills />
      </Reveal>

      {/* ----------------------------------------------------- the band */}
      <Reveal className="mt-20">
        <Band />
      </Reveal>

      {/* ------------------------------------------------------ education */}
      <section aria-labelledby="school" className="mt-20">
        <div className="mb-12">
          <Kicker>Opleiding</Kicker>
          <h2 id="school" className="max-w-[14ch]">
            Waar het <Hl>begon.</Hl>
          </h2>
        </div>

        <Timeline />
      </section>

      {/* ---------------------------------------------------------- outro */}
      <Reveal className="mt-20">
        <Card tone="accent" pad="lg">
          <div className="relative z-10 flex flex-col items-start gap-7 desk:flex-row desk:items-center desk:justify-between">
            <div>
              <Kicker className="!text-void/60">En nu</Kicker>
              <h2 className="max-w-[18ch] text-void">Iets te bouwen?</h2>
              <p className="mt-3 max-w-[44ch] !text-void/75">
                Vertel wat er misloopt. Als ik het kan oplossen zeg ik hoe, en als ik het niet kan
                zeg ik dat ook.
              </p>
            </div>
            <div className="flex shrink-0 flex-wrap gap-2">
              {/* Fixed void/chalk rather than theme tokens: this card is volt
                  at every point of the sunrise, so its buttons must be too. */}
              <Action to="/contact" variant="solid" size="lg" className="bg-void text-chalk">
                Stuur een bericht
                <ArrowRight
                  aria-hidden
                  className="size-4 transition-transform duration-200 group-hover:translate-x-0.5"
                  strokeWidth={2}
                />
              </Action>
              <Action
                to="/projects"
                variant="ghost"
                size="lg"
                className="border-void/25 bg-void/10 text-void hover:border-void/45"
              >
                Eerst het werk zien
              </Action>
            </div>
          </div>
        </Card>
      </Reveal>
    </div>
  );
}
